import styled, { css } from "styled-components";
import { Row, Col } from "antd";
import useTodoTemplateData from "hooks/api/todo/template/useTodoTemplateData";
import ManageTodoListForm from "components/job/index/startJobStep/manageTodoList/form";

const ManageTodoListWithTemplate = (props) => {
  const { todoTemplateId, setDoneCreate } = props;

  const { status: templateDataStatus, data } = useTodoTemplateData({
    todoTemplateId: todoTemplateId,
  });
  return (
    <>
      <StyledChildRow gutter={4}>
        <Col span={24}>
          <StyledContainer>
            <ManageTodoListForm
              tasks={data?.template}
              status={templateDataStatus}
              setDoneCreate={setDoneCreate}
            />
          </StyledContainer>
        </Col>
      </StyledChildRow>
    </>
  );
};

const StyledChildRow = styled(Row)`
  background-color: ${(props) => props.theme.colors.white};

  margin-top: ${(props) => props.theme.spacing[2]};

  ${(props) =>
    props.$newJob &&
    css`
      padding: ${(props) => props.theme.spacing[4]};
    `};
`;

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${(props) => props.theme.spacing[2]};
  max-height: 80vh;
  overflow-y: auto;
`;

export default ManageTodoListWithTemplate;
